export default {"src":"/kaimono/_next/static/media/tw_hk_wamazing_discover_h.7f13757c.svg","height":116,"width":413};